module.exports = __webpack_public_path__ + "img/support_banner.adb1a4cb.jpg";